
import axios from 'axios';

const API_URL = 'https://api.openai.com/v1/chat/completions';

/**
 * Send a message to OpenAI and get a response
 */
export const sendMessageToOpenAI = async (messages: Array<{role: string, content: string}>, apiKey: string) => {
  try {
    // Check if API key is provided
    if (!apiKey) {
      throw new Error('OpenAI API key is not provided. Please set the VITE_OPENAI_API_KEY environment variable.');
    }
    
    const response = await axios.post(
      API_URL,
      {
        model: 'gpt-4o',
        messages,
        temperature: 0.7,
        max_tokens: 800,
        // We're still prioritizing unique selling points, but through the system message instead
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`,
        },
      }
    );

    return response.data.choices[0].message.content;
  } catch (error) {
    console.error('Error calling OpenAI API:', error);
    if (axios.isAxiosError(error) && error.response) {
      console.error('API response:', error.response.data);
      throw new Error(`OpenAI API error: ${error.response.status} - ${error.response.data.error?.message || 'Unknown error'}`);
    }
    throw new Error('Failed to communicate with OpenAI');
  }
};
